import React from "react";
import UserProfile from "./UserProfile";

const Profile = () => {
	const user = JSON.parse(localStorage.getItem("user"));
	return <UserProfile userId={user?.id} />;
};

export default Profile;
